// components/ReviewForm.js
import { React,useState } from 'react';
import { useSubmitReview } from '../Hooks/useSubmitReview';
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";

const ReviewForm = ({ onCancel,id }) => {
  const { submitReview, loading, error } = useSubmitReview();
  const [captchaToken, setCaptchaToken] = useState(null);
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };
  const [formData, setFormData] = useState({
    rating: 0,
    review_title: '',
    review: '',
    name: '',
    email: '',
    product:id
  });
  
  const [hoverRating, setHoverRating] = useState(0); // for hover effect

  // Handle input changes for form fields
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Set the rating value on click
  const setRating = (ratingValue) => {
    setFormData({ ...formData, rating: ratingValue });
  };

  // Submit the form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      toast.error("Please complete the captcha verification.");
      return;
    }
    const result = await submitReview(formData);
    //toast.success("your valuable review is with us now.")
    if (result?.success) {
      onCancel(); // Hide the form after submission
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full border-t-2 py-3 mb-3">
      <h3 className="text-xl font-bold mb-4">Write a review</h3>
      
      {/* Star Rating */}
      <div className="mb-4">
        <label className="block text-sm  mb-2">Rating</label>
        <div className="flex space-x-1">
          {[1, 2, 3, 4, 5].map((star) => (
            <i
              key={star}
              onMouseEnter={() => setHoverRating(star)} // Set hover rating
              onMouseLeave={() => setHoverRating(0)}   // Reset hover rating on mouse leave
              onClick={() => setRating(star)}          // Set actual rating on click
              className={` fa-star cursor-pointer ${
                (hoverRating || formData.rating) >= star ? 'fa-solid text-yellow-500' : 'fa-regular text-yellow-500'
              }`}
            >
            </i>
          ))}
        </div>
      </div>

      {/* Review Title */}
      <div className="mb-4">
        <label className="block text-sm mb-2">Review Title</label>
        <input
          type="text"
          name="review_title"
          value={formData.review_title}
          onChange={handleChange}
          placeholder="Give your review a title"
          className="border border-gray-300 px-4 text-sm p-2 w-full"
          required
        />
      </div>

      {/* Review Content */}
      <div className="mb-4">
        <label className="block text-sm mb-2">Review</label>
        <textarea
          name="review"
          value={formData.review}
          onChange={handleChange}
          placeholder="Write your comments here"
          className="border border-gray-300 px-4 text-sm p-2 w-full"
          rows="4"
          required
        />
      </div>

      {/* Name */}
      <div className="mb-4">
        <label className="block text-sm mb-2">Name</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter your name (public)"
          className="border border-gray-300 px-4 text-sm p-2 w-full"
        />
      </div>

      {/* Email */}
      <div className="mb-4">
        <label className="block text-sm mb-2">Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter your email (private)"
          className="border border-gray-300 px-4 text-sm p-2 w-full"
        />
      </div>
      {process.env.REACT_APP_RECAPTCHA_ENABLER === "true" ? (
          <div className="mb-4">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptchaChange}
            />
          </div>
          ):null}
      {/* Display error if any */}
      {error && <p className="text-red-500">{error}</p>}

      {/* Submit and Cancel buttons */}
      <div className="flex">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border-2 me-2 md:text-lg text-xs border-black text-black font-semibold rounded-xl"
        >
          Cancel Review
        </button>
        
        <button
          type="submit"
          className="px-4 py-2 bg-black md:text-lg text-xs text-white font-semibold rounded-xl"
          disabled={loading}
        >
          {loading ? 'Submitting...' : 'Submit Review'}
        </button>
      </div>
    </form>
  );
};

export default ReviewForm;
